<template>
  <vs-table v-if="show" ref="table" :params="params" :options="options"></vs-table>
</template>

<script>
    import VsTable from "../_framework/VsTable.vue";
    import Constants from "../Constants.js";
    import SelectIntermediateProducts from "../components/SelectIntermediateProducts.vue";
    import {mapState, mapMutations, mapActions} from "vuex";
    import EventBus from "../bus.js";
    import ClientSelect from "../components/ClientSelect.vue";
    import VsSelect from '../_framework/VsSelect.vue';
    import BaseService from "../_framework/api/BaseService";
    import PsSwitch from "../components/PsSwitch.vue";
    import CustomEntity from "../components/CustomEntity";
    import ProductLastPrice from "../components/ProductLastPrice";

    export default {
        name: "Products",
        components: {
            VsTable,
            SelectIntermediateProducts,
            ClientSelect,
            VsSelect,
            PsSwitch,
            CustomEntity,
            ProductLastPrice
        },
        props: ["isSelectMode"],
        data() {
            return {
                unitItems: [],
                access: {},
                show: true,
                params: {
                    entity: "products",
                    list: [],
                    headers: {
                        productCode: {
                            title: "کد محصول",
                            type: "number",
                            isSearchable: true,
                            rowAlignment: "center"
                        },
                        productName: {
                            title: "عنوان محصول",
                            type: "text",
                            isSearchable: true,
                            rowAlignment: "center"
                        },
                        unit: {
                            title: "واحد",
                            type: "custom",
                            isSearchable: false,
                            component: VsSelect,
                            multiple: false,
                            label: "unitValue",
                            rowAlignment: "center",
                            inHeader: true,
                            listParams: {}
                        },
                        sellable: {
                            title: "قابلیت فروش",
                            type: "custom",
                            component: PsSwitch,
                            inHeader: true,
                            rowAlignment: 'center'
                        },
                        lastPrice: {
                            title: "فی موجودی",
                            type: "custom",
                            component: ProductLastPrice,
                            inHeader: false,
                            rowAlignment: "center",
                            mode: "view"
                        },
                    }
                },
                options: {
                    isSelectMode: this.isSelectMode,
                    hasActions: false,
                    beforeCreateEntity: input => {
                        if (input && input["materials"]) {
                            input["materials"] = input["materials"].map(p => {
                                return {
                                    material: p.material.id,
                                    percentage: p.percentage
                                };
                            });
                        }
                        if (input && input["unit"]) {
                            input["unit"] = input["unit"].id || input["unit"];
                        }
                        this.refreshTable();
                        return input;
                    },
                    beforeUpdateEntity: input => {
                        if (input && input["materials"]) {
                        }
                        if (input && input["unit"]) {
                            input["unit"] = input["unit"].id || input["unit"];
                            this.refreshTable();
                        }
                        this.refreshTable();
                        return input;
                    },
                    beforeFetchEntityList: input => {
                        return input;
                    },
                    onRowClicked: row => {
                        this.$emit("onRowSelect", row);
                    },
                    onRowDoubleClicked: row => {
                        this.$emit("onRowDoubleClicked", row);
                    },
                    hasActionsInHeader: false,
                    // onCreateHeaderActionClicked: () => {
                    //   console.log("open modal");
                    // }
                    clickableRows: false,
                    /*getTopRightButtons: () => {
                        let arr = [];
                        let searchToggleButton = {
                            component: "search-toggle-button"
                        };
                        arr.push(searchToggleButton);
                        return arr;
                    },*/
                }
            };
        },
        beforeMount() {
            if (this.$route && this.$route.path) {
                this.options.access = checkAccess(this.$route.path);
            } else {
                this.options.access = checkAccess("products");
            }
            this.show = !!this.options.access;
            this.getUnits();
        },
        mounted() {
            EventBus.$on("materialChanged", () => {
                this.refreshTable();
            });
        },
        computed: {
            ...mapState(["vsTableFeed"])
        },
        methods: {
            getUnits() {
                new BaseService('units', '/GetAll').getList().then((response) => {
                    this.params.headers.unit.listParams.selectItems = response.data;
                }).catch((error) => {
                    console.log(error)
                });
            },
            refreshTable() {
                this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 200);
                this.$refs.table.onFetchEntityList();
            }
        },
        watch: {}
    };
</script>
